import React, { useEffect, useState } from 'react'
import Chart from "react-apexcharts";
import { dateIntoYYYY_MM_DD } from '../../../../utils/dateTimeConverter';
import { postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import DateRange from '../../../../components/DateRange/DateRange';

const ChatActivityGraph = ({ date, selected }) => {



    const [series, setSeries] = useState([{
        name: 'Chats',
        data: [0, 0, 0, 0, 0, 0, 0]
    }])

    const [options, setOptions] = useState({
        chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false,
                allowMouseWheelZoom: false,
            }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                }
            }
        }],
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 10,
                borderRadiusApplication: 'end', // 'around', 'end'
                borderRadiusWhenStacked: 'last', // 'all', 'last'
                dataLabels: {
                    total: {
                        enabled: false,
                        style: {
                            fontSize: '13px',
                            fontWeight: 900
                        }
                    }
                }
            },
        },
        xaxis: {
            categories: [],
        },
        legend: {
            position: 'bottom',
            offsetY: 10
        },
        fill: {
            opacity: 1
        }
    });

    const getData = async () => {
        let postData = {
            filter: selected
        }
        if (selected == 3) {
            postData["startDate"] = dateIntoYYYY_MM_DD(date.startDate);
            postData["endDate"] = dateIntoYYYY_MM_DD(date.endDate);
        }

        let resp = await postApi(postData, urlApi?.chatCountActivityGraph);

        if (resp.responseCode === 200) {

            let localCount = [];
            let localX = [];

            for (const item of resp?.data) {
                if (selected == 1) {
                    let count = item?.hour + 1;
                    localX.push((count > 11 ? (count == 24 ? (count - 12) + "AM" : (count == 12 ? count : (count - 12)) + "PM") : (count + "AM")));
                }
                if (selected != 1) {
                    localX.push(item?.date);
                }
                localCount.push(item.count || 0);
            }

            setSeries([
                {
                    name: 'Chats',
                    data: localCount
                }
            ])

            setOptions({ ...options, xaxis: { ...options.xaxis, categories: localX, type: selected == 1 ? 'time' : 'datetime' } });

        } else {
            setSeries([
                {
                    name: 'Chats',
                    data: [0, 0, 0, 0, 0, 0, 0]
                }
            ])
        }
    }

    useEffect(() => {
        if (selected == 3 && !date?.startDate) {
            return
        }
        getData();
    }, [selected, date])

    return (
        <div className='!mb-4 bg-white p-2 rounded-lg'>
            <div className="flex items-center gap-2 flex-wrap">
                <p className='mb-0 text-xs font-bold text-[var(--grey)]'>Chat Activity</p>
            </div>
            <Chart options={options} series={series} height={'360px'} type="bar" />
        </div>
    )
}

export default ChatActivityGraph